import React from 'react';

// Components
import Form from '@lib/wrappers/Form';
import UniversalInput from '@lib/wrappers/UniversalInput';


// Constants

import { INPUT_TYPES } from '@constants/inputs/inputTypes';


const ComparisonSwitcher = props => {
    const {
        actions: {
            toggleUpdatedFieldsVisibility
        },
        areOnlyUpdatedFieldsShown,
        formName,
        isExtraFinalSummaryPage,
        isExtraSummaryPageShown,
        isSummaryCrashed
    } = props;

    const isShown = isExtraSummaryPageShown && !isExtraFinalSummaryPage;

    const onFieldChange = (...args) => {
        const [ { areOnlyUpdatedFieldsShown } ] = args;
        toggleUpdatedFieldsVisibility(areOnlyUpdatedFieldsShown);
    };

    if(!isShown) {
        return null;
    }

    return (
        <Form { ...{ formName } } >
            <UniversalInput
                label={{
                    text: 'ssap.input.label.display_only_updated_fields',
                }}
                inputData={{
                    isInputRequired: false,
                    classes:[''],
                    disabled: isSummaryCrashed,
                    type: INPUT_TYPES.CHECKBOX,
                    name: 'areOnlyUpdatedFieldsShown',
                    checked: areOnlyUpdatedFieldsShown,
                    value: areOnlyUpdatedFieldsShown,
                    currentData: { areOnlyUpdatedFieldsShown },
                    fields: []
                }}
                inputActions={{
                    onFieldChange
                }}
            />
        </Form>
    );
};

export default ComparisonSwitcher;